import axiosConfig from "../utils/axiosConfig";
import messageCodes from "../utils/messageCodes";
import axios from "axios";

function onGoLiveRequest (logicUrl, showToastForFrontend, showToastForBackend, toGoLiveLogics, callback = null) {
    axios.post(logicUrl + "/golive", toGoLiveLogics, axiosConfig())
        .then(function() {
            if (callback) {
                showToastForFrontend(messageCodes.LOGIC_SAVED);
                callback();
            }
            showToastForFrontend(messageCodes.LOGIC_ACTIVATED);
        })
        .catch((err) => {
            if (err.response) {
                showToastForBackend(err.response.data);
            }
        });
}

export default onGoLiveRequest;
